import { defineComponent as _defineComponent } from 'vue'
import Show from '../collections/Show.vue';

type Props = {
  id: string;
  title: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null
  },
  setup(__props: any) {



return { __sfc: true,Show }
}

})